import shadowV1 from './shadowV1.json';
import shadowV2 from './shadowV2.json';

export type SchemaNames = 'shadowV1' | 'shadowV2';

export const schemas: Record<SchemaNames, any> = {
  shadowV1,
  shadowV2,
};
